import { render, staticRenderFns } from "./AdminSchedules.vue?vue&type=template&id=54ef062c&scoped=true"
import script from "./AdminSchedules.vue?vue&type=script&lang=js"
export * from "./AdminSchedules.vue?vue&type=script&lang=js"
import style0 from "./AdminSchedules.vue?vue&type=style&index=0&id=54ef062c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ef062c",
  null
  
)

export default component.exports